export default __webpack_public_path__ + "static/media/pizza1.e9bbd694.png";